import React from 'react';
import { Quote, Star } from 'lucide-react';
const testimonials = [{
  name: 'Mariana González',
  age: 38,
  location: 'La Plata, Buenos Aires',
  text: 'Antes me pasaba horas buscando textos que los chicos quisieran leer. Con este material, las clases fluyen solas. Los debates que se arman son increíbles. Mis alumnos ahora opinan, discuten y hasta me piden seguir en el recreo.'
}, {
  name: 'Esteban Rodríguez',
  age: 45,
  location: 'Córdoba Capital',
  text: 'Lo mejor es el orden. Sé exactamente qué dar cada semana y no tengo que improvisar. Me devolvió la tranquilidad de ir al aula sabiendo que la clase va a salir bien. Una inversión que vale cada peso.'
}, {
  name: 'Laura Martínez',
  age: 34,
  location: 'Rosario, Santa Fe',
  text: 'Mis alumnos de 5to siempre se quejaban de que Política era aburrida. Desde que uso este sistema, participan un montón. ¡Hasta me piden seguir debatiendo en el recreo! Es increíble el cambio.'
}, {
  name: 'Patricia Sánchez',
  age: 52,
  location: 'CABA, Buenos Aires',
  text: 'Es la primera vez que encuentro un material que realmente entiende los tiempos del aula. No es teoría volada, es práctico y funciona. Después de 25 años de docencia, esto me renovó las ganas de enseñar.'
}, {
  name: 'Javier López',
  age: 41,
  location: 'Mendoza Capital',
  text: 'Me ahorré fines de semana enteros de planificación. Ahora disfruto mucho más dar la materia y los chicos lo notan. El clima del aula cambió completamente. Lo recomiendo a todos mis colegas.'
}];
export function TestimonialsSection() {
  const scrollToPurchase = () => {
    const element = document.getElementById('comprar');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-351">
      <div className="max-w-7xl mx-auto" data-id="element-352">
        <div className="text-center mb-12" data-id="element-353">
          <h2 className="text-3xl font-bold text-[#1e3a5a] mb-4" data-id="element-354">
            Lo que dicen otros docentes
          </h2>
          <div className="flex justify-center gap-1" data-id="element-355">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 text-[#d4a853] fill-[#d4a853]" data-id="element-356" />)}
          </div>
          <p className="text-gray-600 mt-2" data-id="element-357">Más de 500 docentes ya lo usan</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-358">
          {testimonials.map((t, i) => <div key={i} onClick={scrollToPurchase} className="bg-[#FDF6E3] p-6 rounded-xl shadow-sm border border-[#d4a853]/20 relative cursor-pointer transform transition duration-300 hover:-translate-y-1 hover:shadow-lg" data-id="element-359">
              <Quote className="w-8 h-8 text-[#d4a853] absolute top-4 right-4 opacity-50" data-id="element-360" />
              <div className="flex gap-1 mb-4" data-id="element-361">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-[#d4a853] fill-[#d4a853]" data-id="element-362" />)}
              </div>
              <p className="text-gray-700 mb-6 italic relative z-10" data-id="element-363">
                "{t.text}"
              </p>
              <div className="mt-auto pt-4 border-t border-[#d4a853]/20" data-id="element-364">
                <p className="font-bold text-[#1e3a5a]" data-id="element-365">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-366">
                  {t.age} años · {t.location}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}